import React, { useEffect } from 'react'
import RadioGroup from '@material-ui/core/RadioGroup'
import FormControlLabel from '@material-ui/core/FormControlLabel'
import FormControl from '@material-ui/core/FormControl'
import { Typography } from '@material-ui/core'
import clsx from 'clsx'
import classes from './IUIRadio.module.scss'
import { IUIPrimaryRadio } from '../IUIPrimaryRadio'

export const IUIRadio = (props) => {
  const {
    value = '',
    onValueChange = () => {}, // param: { _name, _value, _isError, _errorMsg, _obj, _event }
    list = [],
    disabled = false,
    className = ''
  } = props
  const [radioValue, setRadioValue] = React.useState(value)

  const handleChange = (event) => {
    setRadioValue(event.target.value)
    onValueChange({ _value: event.target.value })
  }

  useEffect(() => {
    setRadioValue(value)
  }, [value])

  return (
    <FormControl component='fieldset'>
      <RadioGroup
        value={radioValue}
        onChange={handleChange}
        className={clsx(classes.customRadio, className)}
      >
        {list &&
          list.length > 0 &&
          list.map((_c, _i) => {
            return (
              <FormControlLabel
                key={_i}
                value={_c.name}
                disabled={disabled}
                control={
                  <IUIPrimaryRadio
                    className={clsx(classes.customRadioEach)}
                    size='small'
                  />
                }
                label={
                  <React.Fragment>
                    <Typography className={clsx(classes.radioLbl)}>
                      {_c.label}
                    </Typography>
                    <Typography className={clsx(classes.radioSubLbl)}>
                      {_c.description}
                    </Typography>
                  </React.Fragment>
                }
              />
            )
          })}
      </RadioGroup>
    </FormControl>
  )
}
